import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Config
import { config } from '../../config';

// Components
import * as icons from '../Icons/Icons';

const Help = observer(class Help extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.renderArticles = this.renderArticles.bind(this);
    this.toggleLinks = this.toggleLinks.bind(this);
  }

  componentWillMount() {
    this.state = {
      collapsed: true,
      docs: [],
      feature: null
    };
  }

  componentDidMount() {
    const _this = this;
    const { HelpStore } = this.props.store;
    const help = document.querySelector('.help');
    const helpBtn = document.querySelector('.help-wrap > button');

    document.onclick = function(e) {
      let target = e.target;
      let collapsed = true;

      while(target.parentNode) {
        if(target === help || target === helpBtn) {
          collapsed = false;
          return true;
        }

        target = target.parentNode;
      }

      _this.setState({
        collapsed
      });
    }

    // Make sure docs are retreived and then set the state
    const helpDelay = setInterval(function(){
      if(HelpStore.helpLoaded) {
        _this.renderArticles();
        clearInterval(helpDelay);
      }
    }, 100);
  }

  /*
  Unsupported logic as o fReact 18, I don't see this being an issue
  shouldComponentUpdate(nextProps, nextState) {
    const thisFeature = this.state.feature;
    const nextFeature = nextProps.store.HelpStore.feature;

    if(thisFeature !== nextFeature) {
      this.renderArticles()
    }

    return true;
  }*/

  renderArticles() {
    const { HelpStore } = this.props.store;
    const { feature } = HelpStore;
    const role = 'proctor';
    let docs = [];

    // // Get the docs for the current feature
    // if(HelpStore.help && HelpStore.help[role]) {
    //   HelpStore.help[role].forEach(article => {
    //     if(article.features.indexOf(feature) > -1) {
    //       docs.push(article);
    //     }
    //   })
    // }

    // Get the docs for the current feature
    if(HelpStore.help && HelpStore.help[feature] && HelpStore.help[feature][role]) {
      docs = HelpStore.help[feature][role];
    }

    this.setState({
      docs,
      feature
    });
  }

  toggleLinks() {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  render() {
    const { translation } = this.props;

    // Get the docs for the current feature
    // if(HelpStore.help[feature] && HelpStore.help[feature][role]) {
    //   docs = HelpStore.help[feature][role];
    // }

    return (
      <div className="help-wrap">
        <button
          className={this.props.btnClass ? this.props.btnClass : ''}
          onClick={this.toggleLinks}
        >
          <icons.iconQuestion />
          {translation.help}
        </button>

        <aside
          className={`help ${this.state.collapsed ? 'help--collapsed' : ''}`}
        >
          {this.state.docs.length > 0 &&
            <h5 className="help__title">{translation.articles}</h5>
          }

          {this.state.docs.length > 0 &&
            <ul className="help__list">
              {this.state.docs.map(
                (doc, i) =>
                <li key={i}>
                  <a
                    target="_blank"
                    href={
                      `${doc.url.indexOf('http') < 0 ? config.docsDomain : ''}${doc.url}`
                    }
                  >
                    <icons.iconInfo />
                    {doc.title}
                  </a>
                </li>
              )}
            </ul>
          }

          <footer className="help__footer">
            <a href="mailto:proctors@smarterproctoring.com?subject=Support%20Ticket">
              {translation.contact}
            </a>
          </footer>
        </aside>
      </div>
    );
  }
})

export default translate('Help')(Help);



// WEBPACK FOOTER //
// ./src/app/components/Help/Help.js